import { ReactNode } from 'react'

type Props = {
    className?: string
    id?: string
    children: ReactNode
    onClick?: () => void
}
const CustomPaper = ({ className, id, children, onClick }: Props) => {
    return (
        <div
            id={id}
            onClick={onClick}
            className={`bg-white rounded-default shadow box-border -:p-5 -:w-full ${className}`}
        >
            {children}
        </div>
    )
}

export default CustomPaper
